import { Stack, Divider, useTheme } from "@mui/material";
import { Button, FoodsIcon, FoodsTags, Typography, WhiteBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import type { TemplateCatalogCategory } from "./templateActionCatalog";

type Props = {
    category: TemplateCatalogCategory;
    added: Set<number>;
    onBack: () => void;
    onSelect: (actionId: number) => void;
};

export const TemplateActionCategory = (props: Props) => {
    const { category, added, onBack, onSelect } = props;

    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Stack gap={theme.spacing(3)}>
            <Stack direction="row" alignItems="center" gap={theme.spacing(1)}>
                <FoodsIcon icon={category.iconName ?? "actionPlan"} size={3} />
                <Typography variant="h4">{category.title}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={theme.spacing(1)}>
                <Button variant="secondary" onClick={() => onBack()}>
                    {t("settings.action_plan_templates.editor.all_categories", "All categories")}
                </Button>
                <Typography component="p" variant="body-regular">
                    ›
                </Typography>
                <FoodsTags label={category.title} />
            </Stack>
            {category.levers.map((lever) => (
                <WhiteBox key={`${lever.id}-template-catalog-lever`}>
                    <Typography variant="h5" sx={{ p: theme.spacing(3) }}>
                        {lever.title}
                    </Typography>
                    <Divider />
                    <Stack divider={<Divider />}>
                        {lever.actions.map((action) => (
                            <Stack
                                key={`${action.id}-template-catalog-action`}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                gap={theme.spacing(2)}
                                sx={{ p: theme.spacing(3) }}
                            >
                                <Typography component="p" variant="body-regular">
                                    {action.title}
                                </Typography>
                                <Stack direction="row" alignItems="center" gap={theme.spacing(1)}>
                                    {added.has(action.id) && (
                                        <FoodsTags label={t("settings.action_plan_templates.editor.added", "Added")} />
                                    )}
                                    <Button
                                        variant="secondary"
                                        disabled={added.has(action.id)}
                                        aria-label={t(
                                            "settings.action_plan_templates.editor.select_action",
                                            "Select {{name}}",
                                            { name: action.title },
                                        )}
                                        onClick={() => onSelect(action.id)}
                                    >
                                        <FoodsIcon icon="plus" size={2} />
                                    </Button>
                                </Stack>
                            </Stack>
                        ))}
                    </Stack>
                </WhiteBox>
            ))}
        </Stack>
    );
};
